import { useWorkspaceCloses } from "@api/close.api";
import { formatCloseTemplateDateRange } from "@components/settings/OrganizationCloseTemplates/formatCloseTemplateDateRange";
import { CellText } from "@design-system/DataGrid";
import { type TaskListTaskRow, toReadOnlyTaskCell } from "./taskRowCells";

const TaskServicePeriod = ({ task }: { task: TaskListTaskRow }) => {
    const { data: closes = [] } = useWorkspaceCloses();
    const close = closes.find(({ id }) => id === task.closeId);

    if (!close || (!close.startDate && !close.endDate)) {
        return null;
    }
    return (
        <CellText
            text={formatCloseTemplateDateRange(close.startDate, close.endDate)}
            overflow="truncate"
        />
    );
};

/** The Service period column: the dates of the task's service. */
export const TaskServicePeriodCell = toReadOnlyTaskCell(TaskServicePeriod);
